<template>
  <section class="convertible_table">
    <!-- 筛选 -->
    <filters
      v-if="!hiddenFilter" 
      class="filters" 
      :config="filterConfig"
      :params="filterParams"
      @filter="filterFn"
      @more="$emit('more')"
    ></filters>

    <!-- 表格 -->
    <e-table 
      class="e_table"
      ref="table"
      :column="column" 
      :data="data" 
      :headerBtns="headerBtns" 
      :total="isOnlyCollect? collectList.length : allData.length"
      stripe
      lazy
      :row-style="{height: '0'}"
      :cell-style="{padding: '3px'}"
      v-bind="{...$attrs, ...$props}"
      @sort-change="sortChange"
      @row-contextmenu="handleRowContextMenu"
    >
      <template v-slot:header_left v-if="!isOnlyCollect">
        共{{ allData.length }}条数据
        <span class="data_tips">无数据权限时为乱序</span>
        <p class="filter_plates">当前热门板块： 
          <span 
            v-for="(it, ind) in hotPlates" 
            :key="it"
            class="filter_plates_item"
            @click="setHotPlatesData(it)"
          >{{ `${ind && '/' || ''}${it}` }}</span>
        </p>
      </template>
      <template v-slot:header_right>
        <el-checkbox 
          v-if="!isOnlyCollect"
          v-model="autoBuyData"
          @change="autoBuyDataFn"
          style="margin-right: 10px"
        >自动订阅数据</el-checkbox>
        <el-checkbox 
          v-if="!isOnlyCollect"
          v-model="autoRefresh"
          @change="autoRefreshFn"
          style="margin-right: 10px"
        >自刷</el-checkbox>
        <el-checkbox 
          v-if="!isOnlyCollect"
          v-model="hiddenRedeem"
          style="margin-right: 10px"
        >隐藏强赎</el-checkbox>
        <el-input class="search" v-model.lazy="searchText" placeholder="输入代码或者名称搜索" size="small" clearable prefix-icon="el-icon-search"></el-input>
      </template>
    </e-table>

    <!-- 申请数据 -->
    <buy-data 
      v-model="buyData.visible"
      @success="buyDataSuccess"
    ></buy-data>

    <!-- 实时行情 -->
    <market
      v-bind="marketDialog"
      v-model="marketDialog.visible"
    ></market>

    <!-- 自定义因子设置弹窗 -->
    <el-dialog
      title="自定义因子设置"
      v-model="customFactorData.visible"
      width="600px"
    >
      <p class="custom_factor_tips">最后根据占比归一权重</p>

      <el-form 
        :model="customFactorData" label-width="120px" style="margin-bottom: 16px;"
      >
        <el-form-item label="常用策略">
          <div style="display: flex; align-items: center; width: 100%;">
            <el-select
              v-model="selectedStrategy"
              placeholder="请选择常用策略"
              style="width: 88%"
              @change="onStrategyChange"
              clearable
              :key="selectedStrategy"
            >
              <el-option
                v-for="item in strategies"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-icon
              style="margin-left: 8px; cursor: pointer; color: #409EFF;"
              @click="isAdding = true"
            >
              <svg viewBox="0 0 1024 1024" width="18" height="18">
                <path d="M480 480V160a32 32 0 1 1 64 0v320h320a32 32 0 1 1 0 64H544v320a32 32 0 1 1-64 0V544H160a32 32 0 1 1 0-64h320z" fill="currentColor"/>
              </svg>
            </el-icon>
          </div>
        </el-form-item>
        <el-form-item label="策略名称">
          <el-input   
            v-model="customFactorData.name" 
            placeholder="请输入策略名称"
            style="width: 88%"
            clearable
          />
        </el-form-item>
      </el-form>

      <el-table :data="customFactorData.data" border style="width: 100%">
        <el-table-column prop="label" label="标签名" width="150"></el-table-column>
        <el-table-column label="权重">
          <template #default="scope">
            <el-input
              v-model="scope.row.weight"
              type="number"
              min="0"
              max="1"
              step="0.001"
              clearable
              style="width: 100%"
              placeholder="请输入权重"
            />
          </template>
        </el-table-column>
        <el-table-column label="分数方向" width="200">
          <template #default="scope">
            <el-switch
              v-model="scope.row.reverse"
              active-text="值大分低"
              inactive-text="值大分高"
              :active-value="1"
              :inactive-value="0"
            />
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="customFactorData.visible = false">取消</el-button>
        <el-button type="primary" @click="saveCustomFactor">保存</el-button>
      </template>
    </el-dialog>


    <!-- 新增策略弹窗 -->
    <el-dialog
      title="新增策略"
      v-model="isAdding"
      width="400px"
      @close="addClear"
    >
      <el-form>
        <el-form-item label="策略名称" label-width="80px">
          <el-input v-model="strategieName" placeholder="请输入策略名称" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addClear">取消</el-button>
        <el-button type="primary" @click="addConfirm">保存</el-button>
      </template>
    </el-dialog>

    <!-- 右键菜单 -->
    <div 
      v-if="contextMenu.visible" 
      class="context-menu"
      :style="{ left: contextMenu.x + 'px', top: contextMenu.y + 'px' }"
    >
      <div class="context-menu-item" @click="analyzeTarget('bond')">
        <span>分析转债（15积分）</span>
      </div>
      <div class="context-menu-item" @click="analyzeTarget('stock')">
        <span>分析正股（15积分）</span>
      </div>
    </div>
  </section>
</template>

<script src="./index.js">
</script>

<style lang="scss" scoped>
.convertible_table{
  padding: 10px 10px 0 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .search{
    margin-right: 10px;
  }
  ::v-deep a{
    color: #0000ee;
  }
  ::v-deep .comprehensive_rating{
    color: red;
  }
  ::v-deep .table_row{
    height: 30px;
  }

  ::v-deep .redeem{
    color: red;
  }
  ::v-deep .adjusted{
    color: green;
  }
  ::v-deep .qsxz{
    color: rgb(179, 135, 212);
  }

  .e_table{
    padding-top: 5px;
    flex: 1;
    overflow: hidden;
  }

  .filters{
    margin-bottom: 5px;
  }
}

.data_tips{
  color: red;
  margin: 0 10px;
  // font-weight: bold;
}
.filter_plates{
  margin-top: 3px;
  font-size: 15px;
  .filter_plates_item{
    cursor: pointer;
  }
}


.custom_factor_tips {
  color: #409EFF;           // Element Plus 主色
  font-size: 14px;
  background: #f4f8ff;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  border-left: 4px solid #409EFF;
}

::v-deep(.el-dialog .el-form) {
  padding: 8px 0 0 0;
}

::v-deep(.el-dialog .el-form-item) {
  margin-bottom: 18px;
  align-items: center;
}

::v-deep(.el-dialog .el-form-item__label) {
  font-size: 15px;
  color: #333;
  font-weight: 500;
  letter-spacing: 1px;
}

::v-deep(.el-dialog .el-input input[type="number"]) {
  height: 38px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  font-size: 15px;
  padding: 0 12px;
  transition: border-color .2s;
  background: #fafdff;
}

::v-deep(.el-dialog .el-input input[type="number"]:focus) {
  border-color: #409EFF;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(64,158,255,0.08);
  outline: none;
}

/* 隐藏原生number输入框的上下箭头 */
::v-deep(.el-dialog .el-input input[type="number"]::-webkit-outer-spin-button),
::v-deep(.el-dialog .el-input input[type="number"]::-webkit-inner-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}
::v-deep(.el-dialog .el-input input[type="number"]) {
  -moz-appearance: textfield;
}

.context-menu {
  position: fixed;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  min-width: 160px;
  padding: 4px 0;

  .context-menu-item {
    padding: 10px 16px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: background 0.2s;

    &:hover {
      background: #f5f5f5;
    }

    span {
      display: block;
    }
  }
}
</style>
